import React from "react";
import "../../Styles/certified/sensiple.css";

export default function Finzly() {
  return (
    <>
      <div className="sensiple-certified-details-section">
        <div className="sensiple-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="sensiple-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="sensiple-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="sensiple-certified-badge"
            />
            <div className="sensiple-certified-company-names">
              <a href="https://www.sensiple.com/careers/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/sensiple/sensiple.png"
                alt="Walkzero Logo"
                className="sensiple-certified-company-logo"
              />
            </a>
              <h1 className="sensiple-certified-full-name">
               Sensiple Software Solutions Pvt. Ltd
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="sensiple-certified-details-right">
            <img
              src="/assets/sensiple/sen_4.jpg"
              alt="Finzly Office"
              className="sensiple-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="sensiple-certified-description">
          <h2>
            Why Sensiple Software Solutions Pvt. Ltd  is an Outstanding Workplaces
          </h2>
          <p>
            Sensiple is a global technology partner helping enterprises reimagine customer and employee experiences through modern, intelligent solutions. Headquartered in New Jersey, USA, with a strong delivery presence in Chennai, India, Sensiple brings over 25 years of industry expertise across Banking and Financial Services, Healthcare, Retail, Logistics, and AI‑led automation.


          </p>
          <p>
            Sensiple delivers value through next‑generation contact centre solutions, intelligent automation, experience transformation, and cloud services. By combining deep domain knowledge with strategic technology partnerships, Sensiple enables organizations to scale securely, operate efficiently, and achieve measurable business impact.
          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="sensiple-certified-info-cards">
          <div className="sensiple-certified-info-card">
            <div className="sensiple-certified-info-title">COMPANY SIZE</div>
            <div className="icom-certified-info-value">300+ Employees</div>
          </div>
          <div className="sensiple-certified-info-card">
            <div className="sensiple-certified-info-title">INDUSTRY</div>
            <div className="sensiple-certified-info-value">IT/Software

</div>
          </div>
          <div className="sensiple-certified-info-card">
            <div className="sensiple-certified-info-title">CONNECT</div>
            <div className="sensiple-certified-info-icons">
              <span className="sensiple-certified-icon-round">
                <a href="https://www.sensiple.com/careers/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="sensiple-certified-icon-round">
                <a href="https://www.linkedin.com/company/sensiple/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="sensiple-certified-icon-round">
                <a href="https://www.facebook.com/pages/Sensiple%20Software%20Solutions/338739239877569/#" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="sensiple-certified-info-card">
            <div className="sensiple-certified-info-title">LOCATION (HQ)</div>
            <div className="sensiple-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="sensiple-certified-recognition-section">
          <h2 className="sensiple-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="sensiple-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="sensiple-certified-recognition-image"
            />
          </div>
          <div className="sensiple-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="sensiple-certified-life-section">
          <h2 className="sensiple-certified-life-title">
            Life at Sensiple Software Solutions Pvt. Ltd
          </h2>
          <div className="sensiple-certified-life-gallery">
            <div className="sensiple-certified-life-col">
              <img src="/assets/sensiple/sen_5.jpeg" alt="Office 1" className="sensiple-certified-life-img" />
              <img src="/assets/sensiple/sen_1.jpg" alt="Team 1" className="sensiple-certified-life-img" />
            </div>
            <div className="sensiple-certified-life-col sensiple-certified-life-center">
              <img src="/assets/sensiple/sen_2.jpeg" alt="Main Office" className="sensiple-certified-life-img sensiple-certified-life-img-large" />
            </div>
            <div className="sensiple-certified-life-col">
              <img src="/assets/sensiple/sen_3.jpeg" alt="Office 2" className="sensiple-certified-life-img" />
              <img src="/assets/sensiple/sen_6.jpeg" alt="Team 2" className="sensiple-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
